import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface CloudTab {
  id:    string;
  label: string;
}

/**
 * Shared tab bar for the Cloud service detail pages (Overview / <resources> /
 * Activity). Extracted from the AWS detail pages so AWS and Azure render an
 * identical tab treatment — same spacing, underline, and active colour.
 */
@Component({
  selector: 'app-cloud-tabs',
  template: `
    <div class="flex border-b border-slate-200 px-6" role="tablist">
      <button
        *ngFor="let tab of tabs"
        (click)="tabChange.emit(tab.id)"
        role="tab"
        [attr.aria-selected]="active === tab.id"
        class="mr-6 border-b-2 py-3 text-sm font-medium transition-colors focus:outline-none"
        [class.border-violet-600]="active === tab.id"
        [class.text-violet-700]="active === tab.id"
        [class.border-transparent]="active !== tab.id"
        [class.text-slate-500]="active !== tab.id"
        [class.hover:text-slate-700]="active !== tab.id"
      >
        {{ tab.label }}
      </button>
    </div>
  `,
})
export class CloudTabsComponent {
  @Input() tabs: CloudTab[] = [];
  @Input() active = '';
  @Output() tabChange = new EventEmitter<string>();
}
